import { useEffect } from "react";
import HeaderBar from "../../common/HeaderBar";
import SideBar from "../../common/SideBar";

import CodingBodyNew from "./CodingBodyNew";
const CodingPageNew = () => {
  // useEffect(() => {
  //   localStorage.removeItem("pdfData");
  // }, [])

  useEffect(() => {
  try {
    localStorage.removeItem("pdfData");
  } catch (err) {
    console.error("Unable to access localStorage:", err);
  }
}, []);

  return (
    <main className="ff2 main-page">
      <HeaderBar />
      <div className="inner-page-content inner-page-content--aira-chat">
        <SideBar />
        <CodingBodyNew />
      </div>
    </main>
  );
};

export default CodingPageNew;